/**
 * @module NotificationsReactUtils
 * @package @geenius/notifications-react
 * @description Provides the React-specific Tailwind class composition helper
 * used by the notifications component and page surfaces. The helper keeps
 * consumer overrides deterministic while resolving conflicting utility classes.
 */

import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merges conditional and static class names with Tailwind conflict resolution.
 *
 * @param inputs Class values, arrays, and conditional fragments to merge.
 * @returns The merged class name string.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}
